export enum JourneyValidation {
  VALID = 'VALID',
  INVALID = 'INVALID',
  LENGTH_EXCEEDED = 'LENGTH_EXCEEDED',
  EMPTY = 'EMPTY'
}

export enum DataLoadingState {
  LOADING = 'LOADING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export enum SetDebounce {
  SET = 'SET',
  NOT_SET = 'NOT_SET'
}
